import { jsx as _jsx } from "react/jsx-runtime";
import { Contrast } from "../../../types/general.types";
import { IconSizes, IconVariants } from "../../Images/Icon/constants";
import Icon from "../Icon/Icon";
import { StyledPlaceHolder } from "./CardholderAvatar.style";
import { CardholderAvatarSizes, CardholderAvatarVariants, } from "./constants";
import MasterLogo from "./icons/MasterLogo";
const CardholderAvatar = ({ size = CardholderAvatarSizes.small, variant = CardholderAvatarVariants.visa, contrast = Contrast.light, }) => {
    const getIconSize = (cardholderSize = "small") => {
        switch (cardholderSize) {
            case CardholderAvatarSizes.small:
                return IconSizes.small;
            case CardholderAvatarSizes.medium:
                return IconSizes.medium;
            case CardholderAvatarSizes.large:
                return IconSizes.large;
        }
    };
    const getVariantIcon = (variant) => {
        switch (variant) {
            case CardholderAvatarVariants.master:
                return "master_logo";
            case CardholderAvatarVariants.visa:
                return "visa_logo";
            case CardholderAvatarVariants.card:
                return "itaufonts_cartao";
            default:
                return "";
        }
    };
    return (_jsx(StyledPlaceHolder, { size: size, children: variant === CardholderAvatarVariants.master ? (_jsx(MasterLogo, { size: getIconSize(size) })) : (_jsx(Icon, { name: getVariantIcon(variant), size: getIconSize(size), variant: IconVariants.neutral, contrast: contrast === Contrast.default ? Contrast.light : contrast })) }));
};
export default CardholderAvatar;
//# sourceMappingURL=CardholderAvatar.js.map